import { ConditionLibraryModuleType } from '@coin/shared/core/util-enums';
import { Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';

export function getModule(router: Router): ConditionLibraryModuleType {
  const componentType = router.url.split('/')[1];
  return (
    Object.values(ConditionLibraryModuleType).find(x => x.toLowerCase() === componentType) ??
    ConditionLibraryModuleType.Default
  );
}

export function getModuleParams(router: Router): HttpParams {
  return new HttpParams().append('Module', getModule(router));
}
